import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface CreatePreferenceParams {
  type: "credits" | "subscription";
  credits_amount?: number;
  jobs_per_month?: number;
}

export function useMercadoPago() {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const createPreference = async (params: CreatePreferenceParams) => {
    setIsLoading(true);

    try {
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        toast({
          variant: "destructive",
          title: "Erro de autenticação",
          description: "Você precisa estar logado para realizar uma compra.",
        });
        return null;
      }

      const response = await supabase.functions.invoke("create-mp-preference", {
        body: params,
      });

      if (response.error) {
        console.error("Error creating preference:", response.error);
        toast({
          variant: "destructive",
          title: "Erro ao criar pagamento",
          description: response.error.message || "Ocorreu um erro ao processar sua solicitação.",
        });
        return null;
      }

      const data = response.data;

      if (data.checkout_url) {
        // Redirect to Mercado Pago checkout
        window.location.href = data.checkout_url;
        return data;
      } else {
        toast({
          variant: "destructive",
          title: "Erro ao criar pagamento",
          description: "Não foi possível obter o link de pagamento.",
        });
        return null;
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      toast({
        variant: "destructive",
        title: "Erro inesperado",
        description: "Ocorreu um erro ao processar sua solicitação. Tente novamente.",
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createPreference,
    isLoading,
  };
}
